var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedHoveredCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 20.5,
    height: 20.5,
    rx: 2.25,
    fill: "white",
    stroke: "var(--primary-color)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5279 6.58417L16.5279 6.58418L8.53345 14.8379L5.47186 11.6782C5.16941 11.3659 4.67593 11.3659 4.37349 11.6782C4.07537 11.9859 4.07537 12.4814 4.37349 12.7892L7.98389 16.5163C8.12855 16.6656 8.32629 16.75 8.53348 16.75C8.74097 16.75 8.93793 16.6654 9.08246 16.5152C9.08263 16.515 9.0828 16.5149 9.08297 16.5147L17.6263 7.69518C17.9244 7.38743 17.9244 6.89193 17.6263 6.58417C17.3239 6.27195 16.8304 6.27195 16.5279 6.58417Z",
    fill: "var(--primary-color)",
    stroke: "var(--primary-color)",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedHoveredCheckbox);
export default __webpack_public_path__ + "static/media/selected-hovered-checkbox.b3af077f98c8f9ef07e74e8075c6b9f7.svg";
export { ForwardRef as ReactComponent };